import type { ReactNode } from "react";
import { WebAppConfig } from "@/infrastructure/services/config/AppConfig";
import { Sentry } from "@/infrastructure/services/logger";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorFallbackProps {
  error: unknown;
}

export function ErrorFallback({ error }: Readonly<ErrorFallbackProps>) {
  const detail =
    WebAppConfig.getInstance().exposeErrorDetails() &&
    error instanceof Error &&
    error.message.trim()
      ? error.message
      : null;

  return (
    <div className="p-6 text-sm text-red-600">
      <p>Something went wrong.</p>
      {detail ? <p className="mt-2 text-xs text-muted-foreground">{detail}</p> : null}
    </div>
  );
}

export const ErrorBoundary = ({ children }: Readonly<ErrorBoundaryProps>) => (
  <Sentry.ErrorBoundary fallback={ErrorFallback}>{children}</Sentry.ErrorBoundary>
);
